const getters = {
    getNotes(state) {
        return state.notes;
    },
    getIsLoading(state) {
        return state.isLoading;
    },
    getNoteById: (state) => (id) => {
        return state.notes.find(note => note.id === id);
    }
}

export default getters;